import { object, func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import interceptUpdater from 'coact-utils/interceptUpdater'


import HeadEditorView from './HeadEditor'

const HeadEditor = scope(
  consumeProps({
    value: object,
    onChange: func.isRequired,
  }),

  interceptUpdater('onChange', () => (value, oldValue) => {
    const {
      brandRef: brandRefOrigin,
    } = value
    const {
      brandRef: oldBrandRefOrigin,
    } = oldValue

    const brandRef = brandRefOrigin || { }

    const brandRefRelated = (brandRefOrigin !== oldBrandRefOrigin) ? {
      brandCode: brandRef && brandRef.brandCode,
    } : { }

    return {
      ...value,
      ...brandRefRelated,
    }
  }),

  exposeProps([
    'value',
    'onChange',
  ]),
)(HeadEditorView)

HeadEditor.displayName = 'HeadEditor'

export default HeadEditor



// WEBPACK FOOTER //
// ./src/components/products/productsD/HeadEditor/index.js